<template>
	<div>
		<div v-if="done">
			<b-container fluid>
				<b-form @submit="onSubmit">

					<input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
<b-form-group label="name">
      <b-form-input
          type="text"
          id="dataItem-name-input"
          class="form-input"
          v-model="dataItem.name"
          @blur="$v.dataItem.name.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.name.required">name is required</div>
      </div>
      </b-form-group>
<b-form-group label="active">
  <b-form-checkbox
    id="dataItem-active-input"
    class="form-input"
    v-model="dataItem.active">active
    </b-form-checkbox>
  </b-form-group>


					<b-button type="submit" variant="primary" style="margin: 5px;">Save</b-button>
					<b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
				</b-form>
			</b-container>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { dataItemDto } from '../../dto';

export default {
  name: 'edit',
  data: () => ({
    done: false,
    dataItem: null,
  	}),
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    getRecord() {
      this.done=false;
      service.getById(this.id).then(data => {
        this.dataItem = data;
        this.done=true;
      });
    },
    async onSubmit(e) {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }

      let payload = new dataItemDto(this.dataItem);

      try {
        const id = await service.update(payload);
        this.redirectToListing();
      } catch {}
    },
    cancel(){
      this.redirectToListing();
    },
    redirectToListing() {
      this.$router.push({ name: 'inventorycategories' });
    },
  },
  mounted() {
    this.getRecord(this.id);
  },
  validations:{
    dataItem:{

      id:{
      },
      name:{
      },
      createdByUserId:{
      },
      modifiedByUserId:{
      },
      dateCreated:{
      },
      dateModified:{
      },
      active:{
      },
    },
  },
}
</script>
